import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getImgFileKey } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import { getlocal, setlocal } from '@src/utils/index';

window.URL = window.URL || window.webkitURL || window.mozURL;

const UploadPic = ({ name, changeInputHandle, updateId, updateSuccess, txt, num }) => {
    const [url, setUrl] = useState('');
    const [uploadState, setUploadState] = useState(1);
    const fileRef = useRef();
    const flieWhiteList = ['jpeg', 'png', 'gif', 'jpg'];

    // const setImgBase64Url = (file) => {
    //     // const img = new Image();

    //     // img.onload = () => {
    //     //     const zipWidth = 240;
    //     //     const zipHeight = 240;
    //     //     const canvas = document.createElement('canvas');
    //     //     const context = canvas.getContext('2d');

    //     //     canvas.width = zipWidth;
    //     //     canvas.height = zipHeight;
    //     //     // 核心JS就这个
    //     //     context.drawImage(img, 0, 0, zipWidth, zipHeight);
    //     //     const dataURL = canvas.toDataURL();

    //     //     setUrl(dataURL);

    //     //     setlocal(`${name}FormBase64Url`, dataURL);
    //     // };
    //     //console.log(URL.createObjectURL(file));
    //     setUrl(URL.createObjectURL(file));
    //     setlocal(`${name}FormBase64Url`, URL.createObjectURL(file));
    // };

    const resetShow = () => {
        const formImageBase64Url = getlocal(`${name}FormBase64Url`);
        const imgKey = getlocal('formData')?.[name] || updateId;

        if (formImageBase64Url && imgKey) {
            setUrl(formImageBase64Url);
        }
    };

    useEffect(() => {
        resetShow();
    }, [updateSuccess]);

    useEffect(async () => {
        const picFileDom = fileRef.current;

        picFileDom.addEventListener('change', async () => {
            // todo限制类型和尺寸 图片20M 视频200M
            const formData = new FormData();
            const file = picFileDom.files[0];
            const fileType = file.type.toLocaleLowerCase().split('/');
            const fileSize = file.size;
            const maxFileSize = 20971520; // 20M转换成b

            // 文件格式校验
            if (!flieWhiteList.includes(fileType.pop())) {
                Toast.show({
                    content: `仅支持${flieWhiteList.join('、')}文件上传`,
                });

                return false;
            }

            // 文件大小校验
            if (fileSize > maxFileSize) {
                Toast.show({
                    content: '图片文件已超过20MB',
                });

                return false;
            }
            setUrl(URL.createObjectURL(file));
            setUploadState(2);
            formData.append('file', file);
            try {
                const fileResult = await getImgFileKey(formData);
                // // 第四步将transaction_id传入必填字段

                changeInputHandle(name, fileResult.url);
                setUploadState(3);
                setlocal(`${name}FormBase64Url`, fileResult.url);
            } catch (error) {
                Toast.show({
                    content: '上传失败',
                });
                setUploadState(4);
            }
           
        });
    }, []);

    // const surveyEndHandle = () => {
    //     alert('报名已结束');
    // };

    return (
        <>
            {uploadState === 2 && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
            <div className={styles.formImageBox}>
                {url ? (
                    <div className={styles.formImageUpload}>
                        <img className={styles.formImageUploadPic} src={url} />
                        <div className={styles.formImageUploadInfo}>重新上传</div>
                    </div>
                ) : (
                    <div className={styles.formImageUploadButton}>
                        {/* <div className={styles.center} />
                        <span className={styles.info}>{txt}</span> */}
                        <div className={styles.bg} />
                    </div>
                )}
                <input
                    ref={fileRef}
                    accept={flieWhiteList.map((item) => `image/${item}`).join(',')}
                    className={styles.formImageUploadInput}
                    // capture="filesystem"
                    type="file"
                />
            </div>
        </>
    );
};

UploadPic.propTypes = {
    name: PropTypes.string,
    changeInputHandle: PropTypes.func,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool
};

export default errorBoundary(UploadPic);
